export const menu = [
  {
    title: 'Розклад',
    icon: 'schedule',
    link: '/schedule',
  },
  {
    title: 'Фінанси',
    icon: 'finances',
    link: '/',
  },
  {
    title: 'Курси',
    icon: 'programs',
    link: '/courses',
  }
];